import axios from "axios";
import { format } from "date-fns";

function getCurrentDate() {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();

  return `${day}-${month}-${year}`;
}

function getCurrentDateTime() {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const milliseconds = String(now.getMilliseconds()).padStart(3, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export const DeleteFaceIoUser = async (faceId) => {
  try {
    const response = await axios.get("https://api.faceio.net/deletefacialid", {
      params: {
        fid: "5b3fbc59007b449284b1f2e11347b3ea", // Target Facial ID to purge
        key: "9084a0e7b4e41d28ca9d4195862d4adf", // Your FACEIO Application API Key
      },
    });

    if (response.data.status !== 200) {
      console.error("Error:", response.data.error);
      return { success: false, error: response.data.error };
    }

    console.log("Facial ID, payload data, and biometric hash purged successfully.");
    return { success: true };
  } catch (error) {
    console.error("Request failed:", error);
    return { success: false, error };
  }
};

export const UserLogin = async (admn, pass, year) => {
  try {
    const body = {
      title: "UserLogin",
      description: "User Login",
      ReqAcaStart: parseInt(year),
      ReqUserID: admn,
      ReqPassWord: pass,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/UserLogin`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetEmployeeDailyAttList = async (dateStr, empCode, ReqCompanyCode) => {
  try {
    const body = {
      title: "GetEmployeeDailyAttList",
      description: "Fetch attendance list",
      ReqAttDate: dateStr,
      ReqEmpCode: empCode,
      ReqCompanyCode: ReqCompanyCode,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetEmployeeDailyAttList`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetEmployeeMasterList = async () => {
  try {
    const body = {
      title: "GetEmployeeMasterList",
      description: "Fetch attendance list",
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetEmployeeMasterList`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetStaffData = async (staffId) => {
  try {
    const body = {
      title: "GetStaffData",
      description: "Fetch staff data",
      ReqStaffId: staffId,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetStaffData`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const StaffRegister = async (data, img) => {
  try {
    const formData = new FormData();
    formData.append("title", "StaffRegister");
    formData.append("description", "Staff Register");
    formData.append("ReqBody", data);
    if (img) {
      formData.append("image", img);
    }
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/StaffRegister`;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const EditStaff = async (data, img) => {
  try {
    const formData = new FormData();
    formData.append("title", "EditStaff");
    formData.append("description", "Staff Register");
    formData.append("ReqBody", data);
    if (img) {
      formData.append("image", img);
    }
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/EditStaff`;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const createLivenessSession = async (videoBlob, sessionId) => {
  try {
    const timestamp = format(new Date(), "dd-MM-yyyy'T'HH-mm-ss");

    let body = {
      sessionId: sessionId,
      timestamp: timestamp,
      video: videoBlob,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/createLivenessSession`;
    const response = await axios.post(url, body, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const checkLivenessSession = async () => {
  try {
    const timestamp = format(new Date(), "dd-MM-yyyy'T'HH-mm-ss");
    const body = {
      title: "checkLivenessSession",
      description: "create Live session",
      timestamp: timestamp,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/checkLivenessSession`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UserVerify = async (img, id, empCode, ReqCompanyCode, ReqAttLocation) => {
  try {
    const timestamp = format(new Date(), "dd-MM-yyyy'T'HH-mm-ss");
    const body = {
      title: "UserVerify",
      description: "User Login",
      image: img,
      timestamp: timestamp,
      ReqAttDate: getCurrentDate(),
      ReqDateNTime: getCurrentDateTime(),
      faceId: id,
      ReqEmpCode: empCode,
      ReqCompanyCode: ReqCompanyCode,
      ReqAttLocation: ReqAttLocation,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/UserVerify`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUserLocationDetails = async (latitude, longitude) => {
  try {
    const body = {
      title: "",
      latitude: latitude,
      longitude: longitude,
    };
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/getUserLocationDetails`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetStaffList = async () => {
  try {
    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetStaffList`;
    const response = await axios.post(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetOrgMasterByCode = async () => {
  try {
    const body = {
      title: "GetOrgMasterByCode",
      description: "Get Organization Master Details",
      ReqOrgAutoID: 1,
    };

    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetOrgMasterByCode`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetStudentsInfoByCode = async (admn, stdyrid, year) => {
  try {
    const body = {
      title: "GetStudentsInfoByCode",
      description: "Get Students full details by code",
      ReqAdmNo: admn,
      ReqAcastart: year,
      ReqStdYrid: stdyrid,
      ReqMode: 15,
    };

    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetStudentsInfoByCode`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetDistance = async (destination) => {
  try {
    const body = {
      title: "GetDistance",
      description: "Get Students full details by code",
      destination: destination,
    };

    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetDistance`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetAllNotifications = async () => {
  try {
    const body = {
      title: "GetAllNotifications",
    };

    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/GetAllNotifications`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetEmployeeList = async (ReqCompanyCode) => {
  try {
    const formData = new FormData();
    formData.append("title", "GetEmployeeListNUserList");
    formData.append("description", "Get Employee List N User List");
    formData.append("ReqCompanyCode", parseInt(ReqCompanyCode));

    const url = `${process.env.REACT_APP_BACKEND_DOTNET_URL}`;
    const response = await axios.post(url, formData);
    const data = JSON.parse(response.data.substring(0, response.data.indexOf("||JasonEnd", 0)));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const AddNotification = async (
  ReqSenderId,
  ReqRecipientScope,
  ReqNotificationType,
  ReqEmployeeCode,
  ReqEmployeeBranch,
  ReqSubject,
  ReqHeading,
  ReqMetadata1,
  ReqMetadata2,
  ReqMetadata3,
  ReqRemarks,
  ReqBase64
) => {
  try {
    const body = {
      title: "AddNotification",
      description: "Get Students full details by code",
      ReqSenderId: ReqSenderId,
      ReqRecipientScope: ReqRecipientScope,
      ReqNotificationType: ReqNotificationType,
      ReqEmployeeCode: ReqRecipientScope === "employees" ? ReqEmployeeCode : "",
      ReqEmployeeBranch: ReqRecipientScope === "branch" ? ReqEmployeeBranch : "",
      ReqSubject: ReqSubject,
      ReqHeading: ReqHeading,
      ReqMetadata1: ReqMetadata1,
      ReqMetadata2: ReqMetadata2,
      ReqMetadata3: ReqMetadata3,
      ReqRemarks: ReqRemarks ?? "created from UI",
      ReqBase64: ReqBase64,
    };

    let url = `${process.env.REACT_APP_BACKEND_NODE_URL}/AddNotification`;
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
